import * as AccordionPrimitive from "@radix-ui/react-accordion";
import * as React from "react";

import { cn } from "@/lib/chillnn/cn";

import ArrowRightIcon from "../icon/arrow-right";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
	React.ElementRef<typeof AccordionPrimitive.Item>,
	React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item> & { borderBottom?: boolean }
>(({ className, borderBottom = true, ...props }, ref) => (
	<AccordionPrimitive.Item
		ref={ref}
		className={cn(borderBottom && "border-b border-b-zinc-200", className)}
		{...props}
	/>
));
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef<
	React.ElementRef<typeof AccordionPrimitive.Trigger>,
	React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
		/**
		 * arrowを左に表示するかどうか
		 */
		arrowLeft?: boolean;
	}
>(({ className, children, arrowLeft = false, ...props }, ref) => {
	const commonTriggerClassName =
		"flex flex-1 items-center py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-90";
	const commonArrowRightClassName = "h-3.5 w-3.5 shrink-0 opacity-50 transition-transform duration-200";

	return (
		<AccordionPrimitive.Header className="flex">
			{arrowLeft ? (
				// arrowを「左」に表示する場合
				<AccordionPrimitive.Trigger
					ref={ref}
					className={cn("gap-x-5", commonTriggerClassName, className)}
					{...props}
				>
					<ArrowRightIcon className={commonArrowRightClassName} />
					{children}
				</AccordionPrimitive.Trigger>
			) : (
				// arrowを「右」に表示する場合
				<AccordionPrimitive.Trigger
					ref={ref}
					className={cn("justify-between", commonTriggerClassName, className)}
					{...props}
				>
					{children}
					<ArrowRightIcon className={commonArrowRightClassName} />
				</AccordionPrimitive.Trigger>
			)}
		</AccordionPrimitive.Header>
	);
});
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
	React.ElementRef<typeof AccordionPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
	<AccordionPrimitive.Content
		ref={ref}
		className={cn(
			"overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
			className,
		)}
		{...props}
	>
		<div className="pb-4 pt-0">{children}</div>
	</AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
